import React, {PureComponent} from "react";
import {connect} from "react-redux";
import {TTP_LOGO_URL} from "../../config/Common";

import Community from "./Community";
import {setCurrentClient} from 'thunks';
import {browserHistory} from "react-router";

@connect((store) => {
  return {
    auth: store.auth,
  };
})

export class SelectCommunity extends PureComponent {

  renderOrganizations() {
    const {user} = this.props.auth;
    if (!user) {
      return null;
    }

    return user.paymentClients.map(client => (
      <Community
        key={client.id}
        community={client}
        onClick={() => this.handleSelectOrganization(client)}
      />
    ));
  }

  handleSelectOrganization = (client) => {
    const { dispatch } = this.props;
    dispatch(setCurrentClient(client));
    // const uri = getEmailingRedirectStorage();
    // if (uri) {
    //   browserHistory.push(uri);
    // }
    // setEmailingRedirectStorage(null);
  };

  render() {
    return (
      <div id="select-community">
        <div className="sc__container">
          <span className="sc__logo">
            <img src={TTP_LOGO_URL} alt="logo"/>
          </span>
          <div className="sc__communities grid-x grid-margin-x">
            {this.renderOrganizations()}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/SelectCommunity/SelectCommunity.js